export enum FixedBackgroundColors {
    DARK_GRADIENT,
    MOVIE_GRADIENT,
    TV_SHOW_GRADIENT,
}
